






























import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import Idf1 from './indicator-form-tab1.vue';
import Idf2 from './indicator-form-tab2.vue';
import Idf3 from './indicator-form-tab3.vue';
import Idf4 from './indicator-form-tab4.vue';
import IndicatorServices, { AlertSetting, IndicatorDto } from '@/services/indicator';
import IndicatorSetServices from '@/services/indicatorSet';
import { checkEmpty } from '@/libs/util';

import { Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { checkCode } from '@/libs/util';

const indChangeAlertSetting: AlertSetting = {
  chgAlertMode: 0,
  chgAlertSettings: [
    {
      alertEvent: '0',
      alertLevel: '3',
      intervalVal1: 50,
      intervalVal2: 9999
    }
  ]
};
@Component({
  components: { Idf1, Idf2, Idf3, Idf4 }
})
export default class DictForm extends mixins(BaseFormMixin) {
  breadList = [{ name: '创建指标' }];
  indSrv = new IndicatorServices();
  indSetSrv = new IndicatorSetServices();
  baseJobInfo: any = {
    cronExpression: '0 0 2 * * ?',
    jobMode: 0,
    jobConfig: {
      rate: 0,
      runDateFormat: '',
      runDateStr: ''
    }
  };

  formData: IndicatorDto = { ...this.baseJobInfo, indChangeAlertSetting, indDefinition: {}, indCompose: {} };
  id: any = 0;
  indSetCode: any = '';
  keepalive: boolean = true;

  created() {
    this.id = this.$route.query.id;
    this.indSetCode = this.$route.query.indSetCode;
    this.initFormData();
  }

  activated() {
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  initFormData() {
    this.formData = { ...this.baseJobInfo, indChangeAlertSetting, indDefinition: {}, indCompose: {} };
    this.current = 0;
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.indSetCode = this.$route.query.indSetCode;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    this.id = this.$route.query.id;
    let path = this.$route.path;

    if (path == '/decision/indicator/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;

      this.initFormData();

      let indSets = await this.indSetSrv.getList({ indSetCode_eq: this.indSetCode });
      this.breadList = [{ name: indSets[0].indSetName }, { name: '创建指标' }];
    } else if (path == '/decision/indicator/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      let res = await this.indSrv.getInfo(this.id);
      this.spinning = false;
      if (!res) return false;
      this.formData = res;
      this.formData.indChangeAlertSetting = JSON.parse(res.indChangeAlertSetting);
      this.formData.jobConfig = JSON.parse(res.jobConfig);
      if (this.formData.indType == 2) {
        this.formData.indCompose = JSON.parse(res.indDefinition);
        this.formData.indDefinition = {};
      } else {
        this.formData.indDefinition = JSON.parse(res.indDefinition);
      }
      this.current = 0;
      this.breadList = [{ name: this.formData.indName || '' }, { name: '编辑指标' }];
    }
  }

  async next() {
    if (this.current === 0) {
      const must: { field: 'indCode' | 'indName' | 'indFirstLevel' | 'indSecondLevel' | 'indDimention'; msessage: string }[] = [
        { field: 'indCode', msessage: '指标编码不能为空' },
        { field: 'indName', msessage: '指标名称不能为空' },
        { field: 'indFirstLevel', msessage: '指标大类不能为空' },
        { field: 'indSecondLevel', msessage: '指标中类不能为空' },
        { field: 'indDimention', msessage: '指标维度不能为空' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
      if (!checkCode(this.formData.indCode)) {
        this.$message.error('编码只能包含英文字母、数字、下划线');
        return false;
      }
      if (!this.id) {
        let code = 'IND_' + this.formData.indCode;
        let exist = await this.indSrv.getList({ indCode_eq: code });
        if (exist.length > 0) {
          this.$message.error(`编码[${code}]已经存在`);
          return false;
        }
      }
    }
    if (this.current === 1) {
      const must: { field: 'indMearsureType' | 'indMearsureUnit' | 'indDataType' | 'indDataFormat' | 'indType'; msessage: string }[] = [
        { field: 'indMearsureType', msessage: '计量类型不能为空' },
        { field: 'indMearsureUnit', msessage: '计量单位不能为空' },
        { field: 'indDataType', msessage: '数据类型不能为空' },
        { field: 'indDataFormat', msessage: '数据格式不能为空' },
        { field: 'indType', msessage: '指标类型不能为空' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }

      let isEmpty = false;
      if (this.formData.indType == '2') {
        // indCompose 组合指标定义
        let { sourceIndSetCode, sourceParamCode, indJoin = [] } = this.formData.indCompose;
        if (!sourceIndSetCode && !sourceParamCode) {
          isEmpty = true;
        }
        if (indJoin.length === 0) isEmpty = true;
        indJoin.forEach((v: any) => {
          if ((!v.indCode && !v.paramCode) || !v.joinOperator) isEmpty = true;
        });
      } else {
        // indDefinition 根指标定义
        let { subCode, aggOperator, indSubs = [] } = this.formData.indDefinition;
        if (!subCode || !aggOperator) {
          isEmpty = true;
        }
        if (indSubs.length === 0) isEmpty = true;
        indSubs.forEach((v: any) => {
          if (!v.dimFieldCode || !v.refDimFieldCode || !v.subComparator) isEmpty = true;
        });
      }

      if (isEmpty) {
        this.$message.error('请将指标定义填写完整');
        return false;
      }
    }
    if (this.current === 2) {
      const must: { field: 'indLevel' | 'indImportance' | 'indIssueRate' | 'indOwnerPlate' | 'indOwnerDept' | 'indOwnerUid'; msessage: string }[] = [
        { field: 'indLevel', msessage: '指标分层不能为空' },
        { field: 'indImportance', msessage: '指标重要性不能为空' },
        { field: 'indIssueRate', msessage: '易出问题率不能为空' },
        { field: 'indOwnerPlate', msessage: '管理板块不能为空' },
        { field: 'indOwnerDept', msessage: '管理部门不能为空' },
        { field: 'indOwnerUid', msessage: '必须搜索并选择指标负责人' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
    }
    this.current++;
  }

  loading: boolean = false;
  async confirm() {
    let indSetCode: any = this.$route.query.indSetCode;
    let parentIndCode: any = this.$route.query.parentIndCode || '';
    let chgAlertSettings: any = this.formData.indChangeAlertSetting?.chgAlertSettings;
    if (chgAlertSettings.length > 0) {
      let isEmpty = false;
      let isError = false;
      chgAlertSettings.forEach((v: any) => {
        if (checkEmpty(v.intervalVal1) || checkEmpty(v.intervalVal2)) isEmpty = true;
        if (v.intervalVal1 >= v.intervalVal2) isError = true;
      });
      if (isEmpty) {
        this.$message.error('分级区间值不能为空');
        return false;
      }
      if (isError) {
        this.$message.error('分级区间值左值必须小于右值');
        return false;
      }
    }
    if (this.id) {
      this.loading = true;
      let res = await this.indSrv.update({ ...this.formData });
      if (res) {
        this.replaceUrlWithOutConfirm(`/decision/indicator/detail?id=${this.id}&indSetCode=${indSetCode}`);
        this.initFormData();
      }
    } else {
      if (!indSetCode) {
        this.$message.error('参数错误：没有指定指标集');
        return false;
      }
      if (parentIndCode) this.formData.parentIndCode = parentIndCode;
      this.formData.indCategoryId = 0;
      this.formData.indSetCode = indSetCode;
      this.loading = true;
      let res = await this.indSrv.add({ ...this.formData });
      if (res) {
        this.replaceUrlWithOutConfirm(`/decision/indicator/detail?id=${res.id}&indSetCode=${indSetCode}`);
        this.initFormData();
      }
    }
    this.loading = false;
    this.HANDLE_RELOAD_IND_MENU();
  }
  @Mutation HANDLE_RELOAD_IND_MENU: any;
}
